import { useLang } from "@/context/LangContext";

export function Marquee() {
  const { t } = useLang();
  const items = ["عطور رويحة", "ATOR RWIHA", t("hero_over"), t("mq_delivery"), t("mq_craft")];
  const row = [...items, ...items];
  return (
    <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#C6A76A]/15 bg-[#0B0B0C] py-8" dir="ltr">
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`px-10 text-4xl sm:text-6xl ${i % 2 ? "text-outline font-serif-latin italic" : "font-display text-[#F7F3EB]"}`} style={/[\u0600-\u06FF]/.test(w) ? { fontFamily: "Amiri, serif" } : undefined}>
                  {w}
                </span>
                <svg viewBox="0 0 12 12" className="h-3 w-3 text-[#C6A76A]">
                  <path d="M6 0 L12 6 L6 12 L0 6Z" fill="currentColor" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
